var _defs, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1396",
    "data-name": "Group 1396",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 234.756,
    height: 219.951,
    viewBox: "0 0 234.756 219.951",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_866",
    "data-name": "Rectangle 866",
    width: 234.756,
    height: 219.951,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_868",
    "data-name": "Rectangle 868",
    width: 190.486,
    height: 16.724,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1391",
    "data-name": "Group 1391"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1390",
    "data-name": "Group 1390",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3336",
    "data-name": "Path 3336",
    d: "M318.389,20.826a22.773,22.773,0,0,0-2.436-5.873l2.48-3.729-3.441-3.441-3.44-3.44-3.729,2.48a22.781,22.781,0,0,0-5.873-2.436L301.066,0h-9.73l-.883,4.386a22.782,22.782,0,0,0-5.873,2.436l-3.729-2.48-3.44,3.44-3.441,3.441,2.48,3.729a22.768,22.768,0,0,0-2.436,5.873l-4.387.883v9.731l4.387.883A22.782,22.782,0,0,0,276.45,38.2l-2.48,3.729,3.441,3.441,3.44,3.44,3.729-2.48a22.782,22.782,0,0,0,5.873,2.436l.883,4.386h9.73l.883-4.386a22.781,22.781,0,0,0,5.873-2.436l3.729,2.48,3.44-3.44,3.441-3.441-2.48-3.729a22.787,22.787,0,0,0,2.436-5.874l4.387-.883V21.709ZM296.2,43.623A17.049,17.049,0,1,1,313.25,26.574,17.049,17.049,0,0,1,296.2,43.623",
    transform: "translate(-92.282)",
    fill: "#b4b8bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3337",
    "data-name": "Path 3337",
    d: "M342.223,89.6a10.43,10.43,0,0,0-1.117-2.692l1.137-1.71-1.577-1.577-1.577-1.577-1.71,1.137a10.444,10.444,0,0,0-2.693-1.117l-.4-2.011h-4.461l-.405,2.011a10.436,10.436,0,0,0-2.691,1.117l-1.71-1.137-1.577,1.577L321.859,85.2,323,86.909a10.432,10.432,0,0,0-1.117,2.692l-2.01.4v4.461l2.01.405A10.432,10.432,0,0,0,323,97.563l-1.137,1.71,1.577,1.577,1.577,1.578,1.71-1.137a10.434,10.434,0,0,0,2.691,1.117l.405,2.011h4.461l.4-2.011a10.442,10.442,0,0,0,2.693-1.117l1.71,1.137,1.577-1.578,1.577-1.577-1.137-1.71a10.43,10.43,0,0,0,1.117-2.692l2.011-.405V90.005Zm-10.171,10.451a7.816,7.816,0,1,1,7.816-7.816,7.816,7.816,0,0,1-7.816,7.816",
    transform: "translate(-109.478 -27.399)",
    fill: "#b4b8bc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_864",
    "data-name": "Rectangle 864",
    width: 23.935,
    height: 72.698,
    transform: "translate(91.37 144.51)",
    fill: "#b4b8bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3338",
    "data-name": "Path 3338",
    d: "M10.511,197.08H196.163a10.511,10.511,0,0,0,10.512-10.512V61.793a10.511,10.511,0,0,0-10.512-10.512H10.511A10.512,10.512,0,0,0,0,61.793V186.568A10.512,10.512,0,0,0,10.511,197.08",
    transform: "translate(0 -17.551)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_865",
    "data-name": "Rectangle 865",
    width: 190.487,
    height: 138.468,
    transform: "translate(8.094 18.212)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1393",
    "data-name": "Group 1393",
    transform: "translate(8.095 18.212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1392",
    "data-name": "Group 1392",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_867",
    "data-name": "Rectangle 867",
    width: 190.486,
    height: 16.724,
    transform: "translate(0 0)",
    fill: "#d2d4d5"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1395",
    "data-name": "Group 1395"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1394",
    "data-name": "Group 1394",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3339",
    "data-name": "Path 3339",
    d: "M146.975,250.636a6.667,6.667,0,1,0,6.667-6.667,6.666,6.666,0,0,0-6.667,6.667",
    transform: "translate(-50.303 -83.501)",
    fill: "#b4b8bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3340",
    "data-name": "Path 3340",
    d: "M108.853,76.156h56.893a2.314,2.314,0,0,0,2.314-2.313v-.33a2.314,2.314,0,0,0-2.314-2.313H108.853a2.314,2.314,0,0,0-2.313,2.313v.33a2.314,2.314,0,0,0,2.313,2.313",
    transform: "translate(-36.464 -24.369)",
    fill: "#dfe1e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3341",
    "data-name": "Path 3341",
    d: "M108.853,89.745h56.893a2.314,2.314,0,0,0,2.314-2.314V87.1a2.314,2.314,0,0,0-2.314-2.313H108.853A2.314,2.314,0,0,0,106.54,87.1v.329a2.314,2.314,0,0,0,2.313,2.314",
    transform: "translate(-36.464 -29.02)",
    fill: "#dfe1e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3342",
    "data-name": "Path 3342",
    d: "M108.853,103.334h56.893a2.314,2.314,0,0,0,2.314-2.313v-.329a2.314,2.314,0,0,0-2.314-2.314H108.853a2.314,2.314,0,0,0-2.313,2.314v.329a2.314,2.314,0,0,0,2.313,2.313",
    transform: "translate(-36.464 -33.671)",
    fill: "#dfe1e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3343",
    "data-name": "Path 3343",
    d: "M107.916,189.559h-71.4a10.811,10.811,0,0,1-10.8-10.8V135.326a10.811,10.811,0,0,1,10.8-10.8h71.4a10.811,10.811,0,0,1,10.8,10.8v43.435a10.811,10.811,0,0,1-10.8,10.8m-71.4-63.677a9.455,9.455,0,0,0-9.445,9.444v43.435a9.456,9.456,0,0,0,9.445,9.445h71.4a9.455,9.455,0,0,0,9.444-9.445V135.326a9.455,9.455,0,0,0-9.444-9.444Z",
    transform: "translate(-8.801 -42.621)",
    fill: "#dfe1e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3344",
    "data-name": "Path 3344",
    d: "M48.236,143.98h60.108a4.769,4.769,0,0,0,4.769-4.769V138.3a4.769,4.769,0,0,0-4.769-4.769H48.236a4.769,4.769,0,0,0-4.769,4.769v.908a4.769,4.769,0,0,0,4.769,4.769",
    transform: "translate(-14.877 -45.704)",
    fill: "#dfe1e8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_869",
    "data-name": "Rectangle 869",
    width: 107.679,
    height: 5.488,
    transform: "translate(49.498 214.463)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3345",
    "data-name": "Path 3345",
    d: "M253.214,138.16A15.5,15.5,0,0,1,242.6,152.873c-.092.032-.186.061-.28.09a15.5,15.5,0,1,1,10.895-14.8",
    transform: "translate(-76.055 -41.981)",
    fill: "#eef0f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3346",
    "data-name": "Path 3346",
    d: "M240.109,140.238s-1.058-6.849,4.614-6.722,5.6,3.513,5.495,6.873-2.274,3.109.178,7.784-2.123,4.675-2.123,4.675l-3.549-4.877Z",
    transform: "translate(-82.153 -45.696)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3347",
    "data-name": "Path 3347",
    d: "M244.137,134.474s-3.842.606-3.993,6.065,1.037,6.622,4.4,5.484,4.423-6.849,4.5-7.733.278-4.473-4.9-3.816",
    transform: "translate(-82.187 -45.998)",
    fill: "#e6e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3348",
    "data-name": "Path 3348",
    d: "M249.155,160.554A3.715,3.715,0,0,1,247,163.982c-.093.032-.187.062-.28.091a15.567,15.567,0,0,1-11.494-.916c-.468-.932.209-2.255,1.584-4.287.944-1.4,1.87-2.82,3.453-3.513,2.336-.372,4.81-.395,6.552.59,1.389.785,2.315,2.21,2.337,4.607",
    transform: "translate(-80.459 -53.091)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3349",
    "data-name": "Path 3349",
    d: "M237.938,159.137l-1.766,2.784c0-.015.122-.437.322-1.657.037-.232.079-.493.122-.784a1.924,1.924,0,0,1,.055-.257,8.159,8.159,0,0,1,3.2-3.083Z",
    transform: "translate(-80.832 -53.44)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3350",
    "data-name": "Path 3350",
    d: "M254.966,163.066a15.418,15.418,0,0,1-2.939,1.33c-.092.032-.186.062-.28.091-.391-1.012-.731-1.886-.805-2.113-.021-.066-.072-.189-.141-.355a11.771,11.771,0,0,1-1.04-3.842c-.006-.868.281-1.58,1.154-1.782a2.263,2.263,0,0,1,.927-.034,2.719,2.719,0,0,1,1.862,1.829c.006.014.011.026.015.039a6.008,6.008,0,0,1,.348,1.239s.015.061.043.17c.055.217.159.628.3,1.167.156.619.352,1.406.56,2.261",
    transform: "translate(-85.483 -53.505)",
    fill: "#e6e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3351",
    "data-name": "Path 3351",
    d: "M247.553,148.3a29.387,29.387,0,0,0-.685,4.533s-4.7,1.775-4.217.771a3.838,3.838,0,0,0,.286-1.558,7.515,7.515,0,0,0-.052-.948c-.012-.1-.022-.162-.022-.162s5.023-3.265,4.69-2.636",
    transform: "translate(-83.038 -50.728)",
    fill: "#e6e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3352",
    "data-name": "Path 3352",
    d: "M242.577,138.343a18.993,18.993,0,0,0,3.766,4.473c1.794,1.264.884,2.274.884,2.274s4.682-9.857.231-10.539-7.181-.733-7.307,5.939c0,0,2.022-2.2,2.426-2.148",
    transform: "translate(-82.194 -45.95)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3353",
    "data-name": "Path 3353",
    d: "M245.7,151.979a4.468,4.468,0,0,1-2.626,1.35h0a7.526,7.526,0,0,0-.052-.948,5.367,5.367,0,0,0,2.679-.4",
    transform: "translate(-83.178 -52.016)",
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3354",
    "data-name": "Path 3354",
    d: "M236.847,159.193h0a3.94,3.94,0,0,0-.185,1.062l.692-1.044s1.235-1.772,1.66-2.233a6.561,6.561,0,0,1,1.037-.866s-2.463,1.17-3.2,3.082",
    transform: "translate(-80.999 -53.43)",
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3355",
    "data-name": "Path 3355",
    d: "M250.6,161.889a26.556,26.556,0,0,1,3.908-1.252s-.606-4.842-3.568-4.329-.339,5.581-.339,5.581",
    transform: "translate(-85.403 -53.485)",
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3356",
    "data-name": "Path 3356",
    d: "M242.121,155.2s-2.213,3.4-1.465,3.7,4.806-.4,6.531-3.63a6.079,6.079,0,0,0-5.067-.071",
    transform: "translate(-82.314 -52.934)",
    fill: "#e6e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3357",
    "data-name": "Path 3357",
    d: "M257.06,66.98a20.087,20.087,0,0,1-4.726,12.974,20.307,20.307,0,0,1-2.253,2.285c-.232.2-.468.4-.708.584q-.406.322-.83.623A20.054,20.054,0,0,1,239.37,87q-.9.11-1.815.141-.33.011-.662.011-.979,0-1.934-.091a20.162,20.162,0,0,1-12.378-5.868c-.124-.125-.247-.252-.367-.38a19.553,19.553,0,0,1-1.28-1.5A20.168,20.168,0,1,1,257.06,66.98",
    transform: "translate(-74.176 -16.022)",
    fill: "#eef0f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3358",
    "data-name": "Path 3358",
    d: "M253.688,91.953,252.2,97.29a20.054,20.054,0,0,1-9.172,3.55q-.895.111-1.815.141-.33.011-.662.011-.979,0-1.934-.091a20.084,20.084,0,0,1-10.342-4.075c-.285-1.765-.591-3.718-.861-5.544,1.483-.552,6.2-2.156,9.177-3.163l.124-.041.193-.066.506-.17c.163-.055.318-.107.463-.158l1.193-.4h0l.06-.02.035,0,4,.3.671.05.21.016.091.023c.241.061.943.245,1.872.528h0c2.37.725,6.218,2.1,7.668,3.771",
    transform: "translate(-77.834 -29.866)",
    fill: "#eef0f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3359",
    "data-name": "Path 3359",
    d: "M245.953,62.221s4.8.81,3.987,8.328-5.052,6.854-5.337,6.843-4.262.091-4.473-9.1c0,0-.06-6.8,5.822-6.07",
    transform: "translate(-82.187 -21.277)",
    fill: "#e6e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3360",
    "data-name": "Path 3360",
    d: "M248.9,81.548a17.352,17.352,0,0,0,.126,3.767c.293.674-3.855,2.8-6.432.378a26.6,26.6,0,0,0,.359-4.576c-.162-1.194,5.947.431,5.947.431",
    transform: "translate(-83.03 -27.613)",
    fill: "#e6e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3361",
    "data-name": "Path 3361",
    d: "M255.031,71.552s.533-.557.72.014-.851,3.106-.787,3.22c0,0-.1.22-.223.1a27.456,27.456,0,0,1,.29-3.331",
    transform: "translate(-87.179 -24.406)",
    fill: "#e6e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3362",
    "data-name": "Path 3362",
    d: "M239.822,71.235s-.51-.578-.72-.015.558,3.094.653,3.25c0,0,.165.26.3.142a27.826,27.826,0,0,0-.229-3.377",
    transform: "translate(-81.822 -24.291)",
    fill: "#e6e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3363",
    "data-name": "Path 3363",
    d: "M250.171,67.133c-.166,1.029-.322,1.793-.322,1.793l-.7.912a18.433,18.433,0,0,0-.065-2.334c-.041-.12-.088-.333-.137-.564-.081-.38-.162-.81-.219-.952-.09-.228-4.115-1.4-7.7.247,0,0,.03.31.028.656,0,.4-.045.854-.23.922-.343.126-.2,2.362-.2,2.362l-.558-.645s-.162-1.168-.321-2.511V67.01c-.036-.314-.073-.635-.108-.955-.08-1.35.053-3.8,1.812-5.242,1.187-.508,3.081-.94,6.239.027a2.169,2.169,0,0,1,.927.244c1.967,2.164,1.556,6.049,1.556,6.049",
    transform: "translate(-82.012 -20.626)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3364",
    "data-name": "Path 3364",
    d: "M243.642,83.786a3.058,3.058,0,0,0,2.547,1.024,3.465,3.465,0,0,0,2.553-.968,3.106,3.106,0,0,1-2.562,1.744,3.141,3.141,0,0,1-2.538-1.8",
    transform: "translate(-83.389 -28.676)",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3365",
    "data-name": "Path 3365",
    d: "M241.851,87.927a5.229,5.229,0,0,0,3.728,2.451c1.549.134,2.889-1.829,3.518-2.793a9.381,9.381,0,0,0-7.246.341",
    transform: "translate(-82.776 -29.782)",
    fill: "#e6e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3366",
    "data-name": "Path 3366",
    d: "M250.591,86.8a13.315,13.315,0,0,1-3.073,2.662l1.3,2,2.217-3.958Z",
    transform: "translate(-84.715 -29.709)",
    fill: "#aeaeae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3367",
    "data-name": "Path 3367",
    d: "M242.337,87.26a8.934,8.934,0,0,0,3.141,2.363l-1.427,2.064-2.494-3.61Z",
    transform: "translate(-82.675 -29.865)",
    fill: "#aeaeae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3368",
    "data-name": "Path 3368",
    d: "M246.924,90.852l1.114,1.7a2.318,2.318,0,0,1-2.258-.042Z",
    transform: "translate(-84.12 -31.095)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3369",
    "data-name": "Path 3369",
    d: "M263.1,91.849l-.032.111c-.122.435-.593,2.109-1.205,4.335-.231.2-.468.4-.708.583q-.407.323-.831.623a20.055,20.055,0,0,1-9.172,3.551c.3-6.981,1.127-13.172,1.127-13.172q.981.258,1.86.511h0a42.771,42.771,0,0,1,8.6,3.247l.019.011c.232.129.339.2.339.2",
    transform: "translate(-85.959 -30.078)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3370",
    "data-name": "Path 3370",
    d: "M235.4,101.031a20.188,20.188,0,0,1-10.28-5.555c-.124-.125-.247-.252-.367-.38-.353-1.5-.587-2.478-.6-2.541v0s2.495-1.64,11.322-4v0c0,.2.005,5.865-.072,12.469",
    transform: "translate(-76.718 -30.309)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3371",
    "data-name": "Path 3371",
    d: "M247.106,93.394c-.082,1.838-.091,5.406-.062,9.476q-.329.011-.662.011-.979,0-1.934-.091a61.851,61.851,0,0,1,1.34-9.4c.1-.407.157-.61.157-.61l1.183.2c-.009.128-.015.267-.022.42",
    transform: "translate(-83.664 -31.754)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3372",
    "data-name": "Path 3372",
    d: "M269.323,95.965a20.319,20.319,0,0,1-2.254,2.285c-.231.2-.468.4-.708.584l1.586-5.239v0a.09.09,0,0,1,.018.012,1.3,1.3,0,0,1,.307.31,9.82,9.82,0,0,1,1.049,2.05",
    transform: "translate(-91.164 -32.033)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3373",
    "data-name": "Path 3373",
    d: "M224.771,97.555c-.124-.125-.247-.252-.367-.38a19.556,19.556,0,0,1-1.28-1.5,2.332,2.332,0,0,1,.677-1.046v0Z",
    transform: "translate(-76.366 -32.388)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3374",
    "data-name": "Path 3374",
    d: "M49.3,41.918H26.674A2.271,2.271,0,0,1,24.4,39.646V37.87A2.271,2.271,0,0,1,26.674,35.6H49.3a2.271,2.271,0,0,1,2.272,2.272v1.776A2.271,2.271,0,0,1,49.3,41.918",
    transform: "translate(-8.352 -12.184)",
    fill: "#f5f7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3375",
    "data-name": "Path 3375",
    d: "M36.871,94.909A13.049,13.049,0,0,0,54.1,82.713c0-.293,0-.585-.016-.873A13.05,13.05,0,1,0,36.871,94.909m-5.6-12.489A9.786,9.786,0,0,1,50.255,79.2l0,.006a9.774,9.774,0,0,1,.57,2.807c.011.216.014.435.013.655a9.785,9.785,0,1,1-19.568-.252",
    transform: "translate(-9.586 -23.786)",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3376",
    "data-name": "Path 3376",
    d: "M53.4,98.444l2.582,2a13.067,13.067,0,0,1-14.5,4.373l1.047-3.094A9.8,9.8,0,0,0,53.4,98.444",
    transform: "translate(-14.198 -33.693)",
    fill: "#d2d4d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3377",
    "data-name": "Path 3377",
    d: "M61.642,88.439l3.262-.177c.015.289.021.581.017.875a12.988,12.988,0,0,1-2.73,7.823l-2.582-2a9.742,9.742,0,0,0,2.047-5.865c0-.22,0-.439-.013-.656",
    transform: "translate(-20.401 -30.208)",
    fill: "#dfe1e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3378",
    "data-name": "Path 3378",
    d: "M62.4,86.488a9.757,9.757,0,0,0-.57-2.807l0-.005,3.07-1.116a12.978,12.978,0,0,1,.764,3.75Z",
    transform: "translate(-21.162 -28.257)",
    fill: "#dfe1e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3379",
    "data-name": "Path 3379",
    d: "M35.912,72.121A13.053,13.053,0,0,1,56.03,78.089L52.962,79.21l0-.005a9.783,9.783,0,0,0-15.133-4.436Z",
    transform: "translate(-12.291 -23.786)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3380",
    "data-name": "Path 3380",
    d: "M189.465,140.094h-8.453a3.042,3.042,0,0,1-3.042-3.041V128.6a3.042,3.042,0,0,1,3.042-3.041h8.453a3.042,3.042,0,0,1,3.042,3.041v8.454a3.041,3.041,0,0,1-3.042,3.041",
    transform: "translate(-60.912 -42.973)",
    fill: "#b4b8bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3381",
    "data-name": "Path 3381",
    d: "M186.28,138.143l-3.675-3.2a.724.724,0,0,1,.951-1.091l2.6,2.266,3.705-4.134a.724.724,0,1,1,1.078.967Z",
    transform: "translate(-62.413 -45.089)",
    fill: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3382",
    "data-name": "Path 3382",
    d: "M189.465,168.415h-8.453a3.042,3.042,0,0,1-3.042-3.042V156.92a3.042,3.042,0,0,1,3.042-3.042h8.453a3.042,3.042,0,0,1,3.042,3.042v8.453a3.041,3.041,0,0,1-3.042,3.042",
    transform: "translate(-60.912 -52.666)",
    fill: "#b4b8bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3383",
    "data-name": "Path 3383",
    d: "M186.28,166.465l-3.675-3.2a.724.724,0,0,1,.951-1.091l2.6,2.265,3.705-4.133a.724.724,0,1,1,1.078.966Z",
    transform: "translate(-62.413 -54.782)",
    fill: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3384",
    "data-name": "Path 3384",
    d: "M189.465,196.736h-8.453a3.042,3.042,0,0,1-3.042-3.042v-8.453a3.042,3.042,0,0,1,3.042-3.042h8.453a3.042,3.042,0,0,1,3.042,3.042v8.453a3.042,3.042,0,0,1-3.042,3.042",
    transform: "translate(-60.912 -62.359)",
    fill: "#b4b8bc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_870",
    "data-name": "Rectangle 870",
    width: 3.344,
    height: 10.965,
    transform: "translate(53.997 60.07)",
    fill: "#dfe1e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3385",
    "data-name": "Path 3385",
    d: "M253.214,194.316a15.5,15.5,0,1,1-15.5-15.5,15.5,15.5,0,0,1,15.5,15.5",
    transform: "translate(-76.055 -61.201)",
    fill: "#eef0f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_871",
    "data-name": "Rectangle 871",
    width: 3.345,
    height: 7.89,
    transform: "translate(48.516 63.145)",
    fill: "#dfe1e8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_872",
    "data-name": "Rectangle 872",
    width: 3.344,
    height: 16.046,
    transform: "translate(59.478 54.988)",
    fill: "#dfe1e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3386",
    "data-name": "Path 3386",
    d: "M245.373,205.346a.78.78,0,0,1-.78-.781v-10.8a.78.78,0,1,1,1.561,0v10.8a.78.78,0,0,1-.781.781",
    transform: "translate(-83.714 -66.051)",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3387",
    "data-name": "Path 3387",
    d: "M247.963,202.755h-10.8a.781.781,0,0,1,0-1.561h10.8a.781.781,0,0,1,0,1.561",
    transform: "translate(-80.904 -68.86)",
    fill: "#949494"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/noData.2dd3afa1a381ec36574197dcc45f1d9e.svg";
export { ForwardRef as ReactComponent };